/**
 * Maps a Loysta subdomain to its portal entry path.
 *   a.loysta.com → /admin
 *   c.loysta.com → /company
 *   v.loysta.com → /vendor
 *
 * Returns null when the host is the bare apex / www / localhost / preview.
 */
export const PORTAL_BY_SUBDOMAIN = {
  a: '/admin',
  c: '/company',
  v: '/vendor',
};

export const getPortalSubdomain = (hostname = window.location.hostname) => {
  const host = hostname.toLowerCase();

  // localhost / 127.0.0.1 / firebase preview / IP — treat as no subdomain
  if (host === 'localhost' || host === '127.0.0.1' || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    return null;
  }

  const parts = host.split('.');
  // Need at least 3 labels (e.g. a.loysta.com) to consider a subdomain
  if (parts.length < 3) return null;

  const sub = parts[0];
  if (sub === 'www') return null;

  return PORTAL_BY_SUBDOMAIN[sub] || null;
};
